import { useEffect } from 'react';
// This exists so we can mock it in tests and run effects by name
export const useNamedEffect = (name, effect, dependencies) => {
    useEffect(effect, dependencies);
};
